import {
  cancelDelayedQueryInvalidation,
  scheduleDelayedQueryInvalidation,
} from '@/helpers/scheduleDelayedQueryInvalidation';
import { reactQueryClient } from '@/utils/reactQueryClient';
import {
  isMedicationDetectionRunComplete,
  MEDICATION_DETECTIONS_QUERY_KEY,
  type MedicationDetection,
  type MedicationDetectionStatus,
} from '@heidi/growth/contracts';

const MEDICATION_DETECTIONS_BOOTSTRAP_INVALIDATE_MS = 2_500 as const;

type MedicationDetectionsQueryData = {
  status?: MedicationDetectionStatus;
  detections: MedicationDetection[];
};

const activeMedicationDetectionsRefetchCleanup: { current: (() => void) | null } = {
  current: null,
};

/** One bootstrap invalidate after note generation; ongoing pending polls use the query hook. */
export const scheduleMedicationDetectionsRefetchAfterNoteComplete = (
  sessionId: string
): (() => void) => {
  const queryKey = [MEDICATION_DETECTIONS_QUERY_KEY, { sessionId }] as const;
  return scheduleDelayedQueryInvalidation({
    queryKey,
    delaysMs: [MEDICATION_DETECTIONS_BOOTSTRAP_INVALIDATE_MS],
    shouldStop: () => {
      const data = reactQueryClient.getQueryData<MedicationDetectionsQueryData>(queryKey);
      return !!data && isMedicationDetectionRunComplete(data);
    },
    activeCleanupRef: activeMedicationDetectionsRefetchCleanup,
  });
};

export const cancelMedicationDetectionsRefetchSchedule = (): void => {
  cancelDelayedQueryInvalidation(activeMedicationDetectionsRefetchCleanup);
};
